import { render, staticRenderFns } from "./Lgx456907876376510464.vue?vue&type=template&id=3d924506&scoped=true&"
import script from "./Lgx456907876376510464.vue?vue&type=script&lang=js&"
export * from "./Lgx456907876376510464.vue?vue&type=script&lang=js&"
import style0 from "./Lgx456907876376510464.vue?vue&type=style&index=0&id=3d924506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d924506",
  null
  
)

export default component.exports